var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "950px" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c("CrearDuodecima"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", [_vm._v("event")]),
              _vm._v(" Duodécimas\n      "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.adicionarDetalle()
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                { staticClass: "pt-0" },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "pt-0",
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { shrink: "" } },
                            [
                              _c(
                                "v-tooltip",
                                { attrs: { bottom: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        slot: "activator",
                                        color: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.crearDuodecima({}, true)
                                        }
                                      },
                                      slot: "activator"
                                    },
                                    [
                                      _c("v-icon", [_vm._v("add")]),
                                      _vm._v(
                                        " Nueva duodécima\n                "
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Crear duodécima")])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-data-table", {
                        staticClass: "elevation-1",
                        attrs: {
                          items: _vm.listado_duodecimas,
                          "hide-actions": "",
                          headers: _vm.headers,
                          loading: _vm.loading_tabla2,
                          "no-data-text": "No se tiene registros",
                          "no-results-text": "No se encontraron coincidencias"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "items",
                            fn: function(props) {
                              return [
                                _c(
                                  "td",
                                  { staticClass: "text-xs-center" },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "rgb(38,60,217)" } },
                                      [_vm._v(_vm._s("event"))]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(props.item.tipo_duodecima) +
                                        "\n              "
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(props.item.estado) +
                                      "\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                props.item.id_estado == 84
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "rgb(217,101,38)",
                                          icon: "",
                                          title: "Editar"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.crearDuodecima(
                                              props.item,
                                              false
                                            )
                                          }
                                        }
                                      },
                                      [_c("v-icon", [_vm._v("edit")])],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                props.item.id_estado == 84
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "rgb(217,38,38)",
                                          icon: "",
                                          title: "Eliminar duodécima"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.eliminarDuodecima(
                                              props.item
                                            )
                                          }
                                        }
                                      },
                                      [_c("v-icon", [_vm._v("delete")])],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                props.item.id_estado == 84
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "rgb(141,51,204)",
                                          icon: "",
                                          title: "Validar duodécima"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.validarDuodecima(
                                              props.item
                                            )
                                          }
                                        }
                                      },
                                      [_c("v-icon", [_vm._v("done")])],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "pr-4" },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(" ACEPTAR\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19a5e305", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19a5e305","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_rrhh/dialogs/CabeceraDuodecima.vue
// module id = null
// module chunks = 